// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAhD9NTiLL6df2_HUOmErxr0D_Hh2gUqFw",
  authDomain: "hal-music-75c80.firebaseapp.com",
  projectId: "hal-music-75c80",
  storageBucket: "hal-music-75c80.firebasestorage.app",
  messagingSenderId: "589767177434",
  appId: "1:589767177434:web:685609e8271d12228361e3",
  measurementId: "G-SG2FC2RNP6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics (optional, ensure you are in a browser environment)
let analytics;
try {
  analytics = getAnalytics(app);
} catch (err) {
  console.warn('Analytics not initialized:', err);
}

// Initialize Firebase Auth and Firestore
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Optionally, export `app` and `analytics` if needed elsewhere
export { app, analytics };
